import styled from 'styled-components';
import { colours } from 'themes/default';

export const StyledDetailsContainer = styled.div`
  margin: 10px 0 0 0;
  width: inherit;
  background-color: white;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledContainer = styled.div`
  padding: 16px;
`;

export const StyledDates = styled.div`
  padding: 6px;
`;

export const StyledListItem = styled.li`
  padding: 4px;
  padding-left: 2px;
`;

export const StyledList = styled.ul`
  margin-top: 0;
  padding-left: 21px;
`;
